<script setup lang="ts">
import { computed, defineProps } from 'vue';

interface GradientOptions {
  direction: string;
  colors: string[];
  opacity?: number;
}

const props = withDefaults(defineProps<{
  id: string;
  transition?: string;
  options: GradientOptions;
}>(), {
  id: '',
  transition: 'herooverlay',
  options: () => {
    return {
      direction: 'to bottom',
      colors: ['#000', '#000'],
      opacity: 0.5
    }
  },
})

const gradientStyle = computed(() => {
  const { direction, colors, opacity = 0.5 } = props.options;
  if(Array.isArray(colors) && colors.length > 0) {
    return {
      background: `linear-gradient(${direction}, ${colors.join(', ')})`,
      opacity: opacity
    };
  }
  return {
    background: 'none',
    opacity: 0
  };
});
</script>

<template>
  <div class="io-hero-overlay gradient" :class="'hero-gradient-' + id" :style="gradientStyle" />
</template>

<style lang="scss" scoped>
.io-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  &.gradient {
    z-index: 1;
  }
}
</style>
